import { useEffect, useState } from "react"
import { useAccount } from "wagmi";
import { getMultiCall, getWeb3Contract } from "../helper/contractHelper";
import { getCurrentChain } from "../helper/functions";
import { CHAIN_INFO } from "../helper/constant";
import nft1155ABI from '../abis/nft1155.json';
import nft721ABI from '../abis/nft721.json';



export const useCommonStats = (nftAddress , type = 'ERC-1155') => {
    const { chainId } = useAccount();
    const [stats, setStats] = useState({
        price: 0,
        owner : ''
    });

    let currentChain = getCurrentChain(chainId);
    const sc = getWeb3Contract(type === 'ERC-1155' ? nft1155ABI : nft721ABI , nftAddress ? nftAddress : CHAIN_INFO[currentChain].default_nft, currentChain)

    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    sc.methods.price(),
                    sc.methods.owner()
                ], currentChain);

                console.log(data)

                setStats({
                    price: data[0] / Math.pow(10,18),
                    owner : data[1]
                });
            }
            catch (err) {
                console.log(err.message);
            }
        }

        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chainId,nftAddress,type]);

    return stats;
}